import React, { useState } from "react";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../../libs/api/Endpoints";
import s from "./MutateVerification.module.scss";
import { generateResult } from "../../../../../../../global components/ResultModal/ResultModal";
import { UseAuthToken } from "../../../../../../../libs/api/userSession";
import { SuccessDataType } from "../../../../../../../libs/api/types";
import { Button } from "antd";
import { generateConfirmation } from "../../../../../../../global components/DestructiveModal/DestruvtiveModal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
type Prop = {
  userId: string | null;
  documentId: string | undefined;
  handleModal: () => void;
  mutate?: () => void;
  src: string | string[] | undefined;
  status: string;
};
function MutateVerification({
  documentId,
  userId,
  handleModal,
  mutate,
  status,
  src,
}: Prop) {
  const token = UseAuthToken();
  const [value, setValue] = useState<string>("");
  const { trigger: reject, isMutating } = useSWRMutation(
    `api/admin/users/${userId}/verifications/${documentId}/reject`,
    swrMutationFetcher,
  );
  const { trigger: accept, isMutating: isLoading } = useSWRMutation(
    `api/admin/users/${userId}/verifications/${documentId}/approve`,
    swrMutationFetcher,
  );
  const approveDocument = async () => {
    try {
      if (token) {
        const fetcherArg: SwrMutationFetcherArgType = {
          token: token,
          requestOption: {
            method: "PATCH",
          },
        };
        const result: SuccessDataType<any> = await accept(fetcherArg);
        generateResult(
          "success",
          result.message.charAt(0).toUpperCase() + result.message.slice(1),
        );
        handleModal();
        setValue("");
        mutate && mutate();
      }
    } catch (error) {
      const e = parseClientError(error);
      generateResult("error", e.message || "Something went wrong");
      handleModal();
    }
  };
  const rejectDocument = async () => {
    try {
      const fetcherArg: SwrMutationFetcherArgType = {
        token: token,
        requestOption: {
          method: "PATCH",
          body: JSON.stringify({ reason: value }),
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
      const result: SuccessDataType<any> = await reject(fetcherArg);
      generateResult("success", result.message);
      handleModal();
      setValue("");
      mutate && mutate();
    } catch (error) {
      const e = parseClientError(error);
      generateResult("error", e.message || "Something went wrong");
      handleModal();
    }
  };
  return (
    <div className={s.wrapper}>
      {typeof src === "string" ? (
        <img src={src} className={s.doc} alt="doc" />
      ) : (
        <Swiper
          modules={[Navigation, Pagination]}
          navigation={true}
          autoplay={false}
          loop={true}
          className={s.slideContainer}
          slidesPerView={1}
          spaceBetween={30}
        >
          {src?.map((item) => (
            <SwiperSlide key={item} className={s.wrapper}>
              <img src={item} alt="doc" className={s.doc} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      <hr />

      {status === "pending" && (
        <div className={s.inputWrapper}>
          <h5 className={s.inputLabel}>Reason for rejection</h5>
          <input
            className={s.input}
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </div>
      )}
      {status !== "approved" && (
        <>
          <div className={s.btnGroups}>
            {status === "pending" && (
              <Button
                className={s.rejectBtn}
                loading={isMutating}
                onClick={() =>
                  generateConfirmation(
                    "Are you sure you want to reject this docs?",
                    "",
                    rejectDocument,
                    isMutating,
                    "reject",
                  )
                }
              >
                Reject
              </Button>
            )}
            {status === "pending" && (
              <Button
                onClick={approveDocument}
                loading={isLoading}
                className={s.approveBtn}
              >
                Approve
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default MutateVerification;
